export const DEFAULT_VIBRATION_STYLE = 'medium' as const

export type VibrationStyle = 'light' | 'medium' | 'heavy'
export type VibrationCode = 'OK' | 'UNSUPPORTED' | 'INVALID_ARGUMENT' | 'FAILED'

export interface VibrateResult {
  success: boolean
  style: VibrationStyle
  code: VibrationCode
}

export interface VibrateParams {
  style?: unknown
}

export function isVibrationStyle(value: unknown): value is VibrationStyle {
  return value === 'light' || value === 'medium' || value === 'heavy'
}

/** 缺省不传字段，由原生统一采用 medium。 */
export function buildVibrateParams(style?: unknown): VibrateParams {
  return style === undefined ? {} : { style }
}

/** 兼容 iOS 对象与 Android/HarmonyOS JSON 字符串返回。 */
export function normalizeVibrateResult(
  raw: unknown,
  fallbackStyle: VibrationStyle = DEFAULT_VIBRATION_STYLE,
): VibrateResult {
  let value = raw
  if (typeof raw === 'string') {
    try {
      value = JSON.parse(raw)
    } catch {
      return { success: false, style: fallbackStyle, code: 'FAILED' }
    }
  }
  if (!value || typeof value !== 'object') {
    return { success: false, style: fallbackStyle, code: 'FAILED' }
  }
  const result = value as Partial<VibrateResult>
  const code: VibrationCode = ['OK', 'UNSUPPORTED', 'INVALID_ARGUMENT', 'FAILED'].includes(result.code || '')
    ? result.code as VibrationCode
    : 'FAILED'
  return {
    success: result.success === true,
    style: isVibrationStyle(result.style) ? result.style : fallbackStyle,
    code,
  }
}
